export default "__VITE_ASSET__9dHfz5k3__";